import I18n from 'app/i18n';

const dateLabel = () => `${I18n.t('date_label')} (${window.settings.user.time_zone.name})`;

export default dateLabel;
